import { motion, useTransform } from "framer-motion"

import brand from "../design/branding.jpg"
import code from "../design/code.jpg"
import more from "../design/design.jpg"
import pc from "../design/pc.jpg"

function WorkCard({ content }) {


    return (
        <motion.div className="pointer card-wrapper"
            initial={{ y: 100, opacity: 0 }}
            whileInView={{ y: 0, opacity: 1 }}
            transition={{ duration: 0.5 }}
        >
            <h2>{content.name}</h2>
        </motion.div>
    )
}

export default function OurWork({ scrollY }) {

    const h = window.innerHeight * 2
    const h2 = window.innerHeight
    const m = window.innerWidth < 768;

    const y = useTransform(scrollY, [0, h - 100, h, h + 100], [ h2, 60, 0, 60], {
        clamp: true
    })

    const yHeader = useTransform(scrollY, [0, h - 100, h, h + 100], [ h2, 60, 0, 60], {
        clamp: true
    })

    const opacity = useTransform(scrollY, [0, h - 100, h], [0, 0.5, 1], {
        clamp: true
    })

    const docs = [
        {
            logo: code,
            name: "Web Development"
        },
        {
            logo: pc,
            name: "Mobile App Development"
        },
        {
            logo: brand,
            name: "Branding"
        },
        {
            logo: more,
            name: 'See All'
        }
    ]

    return (
        <div style={{ backgroundColor: "#000" }}>
            <motion.div id="our-work"
                style={{ position: 'relative' }}
                transition={{
                    duration: 0.8
                }}
            >
                <div 
                    style={{ height: "10vh" }}
                />
                <motion.div style={{ y: m ? 0 : yHeader }} className="content">
                    <h1>Our Services</h1>
                </motion.div>
                <motion.div style={{ y: m ? 0 : y, opacity: m ? 1 : opacity }} id="work-content">
                    {docs.map(data => (
                        <WorkCard key={data.name} content={data} />
                    ))}
                </motion.div>
            </motion.div>
        </div>
    )
}